import PropTypes from "prop-types";

export function Card({ className, children, ...props }) {
  return (
    <div
      className={`rounded-lg border bg-card text-card-foreground shadow ${
        className || ""
      }`}
      {...props}
    >
      {children}
    </div>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export function CardContent({ className, children, ...props }) {
  return (
    <div className={`p-0 pt-0 ${className || ""}`} {...props}>
      {children}
    </div>
  );
}

CardContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
